import { typeReservationConstants } from './typeReservation.constants'

const {
    FETCHING_TYPE_RESERVATION_SUCCESS,
} = typeReservationConstants

const setTypeReservation = (typeReservation) => {
  return dispatch => {
    dispatch({ type: FETCHING_TYPE_RESERVATION_SUCCESS, typeReservation });    
  };
}

export default {
  setTypeReservation,
}